module.exports = __webpack_public_path__ + "static/media/recapture.5f525808.png";